import { render, staticRenderFns } from "./new_blog.vue?vue&type=template&id=05f52ead&scoped=true&"
import script from "./new_blog.vue?vue&type=script&lang=js&"
export * from "./new_blog.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f52ead",
  null
  
)

export default component.exports